import { useMutation } from '@tanstack/react-query'
import { useMe } from '@/shared/hooks/useMe'
import { bulkCreateDebtors } from '../services/bulkUploadServices'
import type { Currency } from '@/shared/models/moneyModel'

export type BulkUploadState =
    'idle' | 'working_short' | 'working_medium' | 'working_long' | 'success' | 'error' | 'canceled'

export const bulkQueryKeys = {
    root: ['bulk'] as const,
    bulkDebtors: () => [...bulkQueryKeys.root, 'debtors'] as const
} as const

type CreditLimitOptions = {
    shouldCreateCreditLimit: true
    currency: Currency
}

type NoCreditLimitOptions = {
    shouldCreateCreditLimit?: false
    currency?: undefined
}

type BulkVars = { file: Blob; options?: NoCreditLimitOptions } | { file: Blob; options: CreditLimitOptions }

export function useBulkCreateDebtors() {
    const { companyId } = useMe()

    const mutation = useMutation<Blob, unknown, BulkVars>({
        mutationKey: bulkQueryKeys.bulkDebtors(),
        mutationFn: async ({ file, options }) => bulkCreateDebtors(file, companyId, options)
    })

    return {
        ...mutation
    }
}
